import React from 'react';
import { Button, Table, InputNumber, Input } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { FG114 } from '../../../services/pwg201Api';

interface Props {
  rows: FG114[];
  isEditing: boolean;
  onChange: (rows: FG114[]) => void;
}

const WriteoffAdv2Tab: React.FC<Props> = React.memo(({ rows, isEditing, onChange }) => {
  const addRow = () => {
    onChange([
      ...rows,
      { fg114_01: '', fg114_02: rows.length + 1, fg114_11: '', fg114_12: 'NTD', fg114_13: 0, fg114_14: 0, fg114_90: 0, fg114_91: '', fg114_92: null, fg114_93: '' },
    ]);
  };

  const deleteRow = (idx: number) => onChange(rows.filter((_, i) => i !== idx));

  const updateRow = (idx: number, field: keyof FG114, value: any) => {
    const updated = [...rows];
    (updated[idx] as any)[field] = value;
    onChange(updated);
  };

  const columns: ColumnsType<FG114> = [
    { title: <span data-contract-field="fg114_02">序</span>, dataIndex: 'fg114_02', width: 50 },
    {
      title: <span data-contract-field="fg114_11">代墊款單號</span>,
      dataIndex: 'fg114_11',
      render: (v, _, i) =>
        isEditing ? (
          <Input size="small" value={v} onChange={e => updateRow(i, 'fg114_11', e.target.value)} />
        ) : v,
    },
    {
      title: <span data-contract-field="fg114_12">幣別</span>,
      dataIndex: 'fg114_12',
      width: 70,
      render: (v, _, i) =>
        isEditing ? (
          <Input size="small" value={v} maxLength={3} onChange={e => updateRow(i, 'fg114_12', e.target.value)} />
        ) : v,
    },
    {
      title: <span data-contract-field="fg114_13">沖銷金額</span>,
      dataIndex: 'fg114_13',
      width: 120,
      render: (v, _, i) =>
        isEditing ? (
          <InputNumber size="small" value={v} style={{ width: '100%' }} onChange={val => updateRow(i, 'fg114_13', val ?? 0)} />
        ) : v,
    },
    ...(isEditing
      ? [{
          title: '',
          width: 40,
          render: (_: any, __: FG114, i: number) => (
            <Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteRow(i)} />
          ),
        }]
      : []),
  ];

  return (
    <div>
      <Table size="small" columns={columns} dataSource={rows} rowKey={(_, i) => `adv2-${i}`} pagination={false} />
      {isEditing && (
        <Button icon={<PlusOutlined />} onClick={addRow} style={{ marginTop: 8 }}>
          新增沖代墊款
        </Button>
      )}
    </div>
  );
});

export default WriteoffAdv2Tab;
